import { render, staticRenderFns } from "./FaceImgMultiUpload.vue?vue&type=template&id=135f85f2"
import script from "./FaceImgMultiUpload.vue?vue&type=script&lang=js"
export * from "./FaceImgMultiUpload.vue?vue&type=script&lang=js"
import style0 from "./FaceImgMultiUpload.vue?vue&type=style&index=0&id=135f85f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports